import React, {PureComponent} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './MacroList.scss';

const UP_KEY_CODE = 38;
const DOWN_KEY_CODE = 40;
const ENTER_KEY_CODE = 13;

class MacroList extends PureComponent {
    static propTypes = {
        onSelect: PropTypes.func.isRequired,
        list: PropTypes.array,
        visible: PropTypes.bool,
        processing: PropTypes.bool,
        macroDropDownPosition: PropTypes.shape({
            top: PropTypes.number,
            left: PropTypes.number,
        }),
    };

    static defaultProps = {
        list: [],
        processing: false,
        visible: false,
        macroDropDownPosition: {
            top: 0,
            left: 0,
        }
    };

    state = {
        focused: null,
    };

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (event) => {
        const {keyCode} = event;
        if (![UP_KEY_CODE, DOWN_KEY_CODE, ENTER_KEY_CODE].includes(keyCode)) {
            return;
        }

        event.preventDefault();

        if (keyCode === UP_KEY_CODE) {
            this.focusPrev();
        }

        if (keyCode === DOWN_KEY_CODE) {
            this.focusNext();
        }

        if (keyCode === ENTER_KEY_CODE) {
            const {list} = this.props;
            const {focused} = this.state;
            const selected = !list[focused] ? list[0] : list[focused];
            this.handleSelect(selected, event)
        }
        event.stopPropagation();
    }

    focusNext = () => {
        const {focused} = this.state;
        const {list} = this.props;

        this.setState({
            focused: focused === list.length - 1
                ? 0
                : focused === null ? 0 : focused + 1,
        })
    }

    focusPrev = () => {
        const {focused} = this.state;
        const {list} = this.props;

        this.setState({focused: !focused ? list.length - 1 : focused - 1})
    }

    handleSelect(item, event) {
        const {onSelect} = this.props;
        event.preventDefault();
        event.stopPropagation();

        onSelect(item);
    }


    renderItem = (item, key) => {
        const {focused} = this.state;
        return (
            <div
                className={classnames(styles.item, {[styles.focused]: key === focused})}
                key={key}
                onClick={this.handleSelect.bind(this, item)}
                role="button"
            >
                {item.text}
            </div>
        );
    };

    render() {
        const {
            listRef,
            list,
            macroDropDownPosition,
            visible,
            processing,
        } = this.props;

        return ReactDOM.createPortal(
            (
                <div
                    ref={listRef}
                    className={classnames(styles.container, {[styles.visible]: visible})}
                    style={macroDropDownPosition}
                    onClick={this.handleContainerClick}

                >
                    {!processing
                        ? list.map(this.renderItem)
                        : <div className={styles.processing}>{loc('processing')}</div>
                    }
                </div>
            ),
            document.getElementById('rootContainer'),
        );
    }
}

export default MacroList;



// WEBPACK FOOTER //
// ./src/components/controls/MacroList.jsx